module.exports = __webpack_public_path__ + "static/media/adelaide-logo.ca617f9b.svg";